export default "__VITE_ASSET__DGjKwlVz__"